import { FC, useMemo } from 'react';
import { Link } from '@remix-run/react';
import { useSemanticUrlBuilder } from '~/utils/use-semantic-url-builder';
import { useActiveToCurrentArticle } from '@article/shared/utils/use-active-to-current-article';
import useReflowClick from '~/utils/use-reflow-click';
import { ClickPosition } from '~/utils/click-position';

import './style.scss';

interface ILegacyHashtagItemProps {
  hashtag: {
    id: string;
    name: string;
  };
}

export const LegacyHashtagItem: FC<ILegacyHashtagItemProps> = (props) => {
  const { hashtag } = props;
  const buildSemanticUrl = useSemanticUrlBuilder();
  const activeToCurrentArticle = useActiveToCurrentArticle();

  const to = useMemo(() => buildSemanticUrl(`/topic/${hashtag.id}`), []);

  const handleHashtagClick = useReflowClick(
    {
      clickEvent: () => ({
        current_position: ClickPosition.main_hashtag,
        page_click_id: hashtag.id,
      }),
      reflowBehavior: () => {
        activeToCurrentArticle(ClickPosition.main_hashtag, hashtag.id);
      },
    },
    [activeToCurrentArticle],
  );

  return (
    <Link to={to} onClick={handleHashtagClick} className="legacy-hashtag-item">
      #{hashtag.name}
    </Link>
  );
};
